import { MEDIA_TYPE } from '../base/media/constants';
import { toState } from '../base/redux/functions';
import { isLocalTrackMuted } from '../base/tracks/functions';
import { addHashParamsToURL } from '../base/util/uri';
/**
 * Adds the current track state to the passed URL.
 *
 * @param {URL} url - The URL that will be modified.
 * @param {Function|Object} stateful - The redux store or {@code getState} function.
 * @returns {URL} - Returns the modified URL.
 */
export function addTrackStateToURL(url, stateful, password) {
    const state = toState(stateful);
    const tracks = state['features/base/tracks'];
    const isVideoMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
    const isAudioMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
    let options = {
        'config.startWithAudioMuted': isAudioMuted,
        'config.startWithVideoMuted': isVideoMuted
    };
    if (password) {
        options = {
            ...options,
            'password': password
        };
    }
    // const _new = addHashParamsToURL(new URL(url), { // use new URL object in order to not pollute the passed parameter.
    //     'config.startWithAudioMuted': isAudioMuted,
    //     'config.startWithVideoMuted': isVideoMuted
    // });
    // const _new2 = addHashParamsToURL(new URL(url), { // use new URL object in order to not pollute the passed parameter.
    //     'config.startWithAudioMuted': isAudioMuted,
    //     'config.startWithVideoMuted': isVideoMuted,
    //     'pwd': '1111'
    // });
    return addHashParamsToURL(new URL(url), options);
}
export function checkSipGateway() {
    return localStorage.getItem('iAmSipGateway') == 'true';
}
export function checkRecorder(deepCheek, state) {
    const defaultCheck = localStorage.getItem('iAmRecorder') == 'true' && !checkSipGateway();
    if (state && deepCheek) {
        const { iAmRecorder } = state['features/base/config'];
        return defaultCheck || iAmRecorder;
    }
    return defaultCheck;
}
export function checkIsJibri() {
    return localStorage.getItem('iAmRecorder') == 'true' || checkSipGateway();
}
